import { ChangeCustomersState } from "@dana/Store/Data/ChangeCustomers/ChangeCustomersState";
import { CustomersCollectionModel } from "@dana/Types/ApiModels";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { GetBillTosApiParameter } from "@insite/client-framework/Services/CustomersService";
import { setDataViewLoaded, setDataViewLoading } from "@insite/client-framework/Store/Data/DataState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

const initialState: ChangeCustomersState = {
    isLoading: {},
    byId: {},
    dataViews: {},
};

const reducer = {
    "Data/AllCustomers/BeginLoadAllCustomers": (draft: Draft<ChangeCustomersState>, action: { parameter: GetBillTosApiParameter }) => {
        setDataViewLoading(draft, action.parameter);
    },

    "Data/AllCustomers/CompleteLoadAllCustomers": (
        draft: Draft<ChangeCustomersState>,
        action: { parameter: GetBillTosApiParameter; collection: CustomersCollectionModel },
    ) => {
        setDataViewLoaded(draft, action.parameter, action.collection, collection => collection.billTos!);
    },
};

const changeCustomerReducer =  createTypedReducerWithImmer(initialState, reducer);

(reducers as any).changeCustomersState = changeCustomerReducer;
type ChangeCustomerExtReducers ={
    changeCustomersState:typeof changeCustomerReducer;
};
export type changeCustomeCustom = Parameters<ChangeCustomerExtReducers[keyof ChangeCustomerExtReducers]>[1] | AnyAction;